var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayoutDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 10.5,
    width: 12.5,
    y: 2.75,
    x: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.25 6.75h5.5m-11.5 2.5h5.5m.25-6v9.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutDashboard);
export default __webpack_public_path__ + "static/media/layout-dashboard.c979546a90088e6a79f64314e83cdd69.svg";
export { ForwardRef as ReactComponent };